import React, { useEffect, useRef } from "react";
import { Toolbar, useTheme } from "@mui/material";
import { Box, IconButton, Typography } from "@mui/material";
import { ArrowBackIcon } from "@verily-src/react-design-system";
import { Steps } from "common/Steps";
import { focusOnRef, sxFocusWithin } from "common/Accessibility";
import TopAppBar from "./TopAppBar";

interface StepsHeaderProps {
  scrollTarget?: HTMLDivElement;
  title: string;
  stepId: number;
  steps: Steps;
  onClose: () => void;
  focusOnTitle?: boolean;
}

const StepsHeader: React.FC<StepsHeaderProps> = ({
  scrollTarget,
  title,
  stepId,
  steps,
  onClose,
  focusOnTitle = true,
}) => {
  const theme = useTheme();

  const titleRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    setTimeout(() => {
      if (focusOnTitle) {
        focusOnRef(titleRef);
      }
    }, 0);
  }, [focusOnTitle]);

  return (
    <TopAppBar scrollTarget={scrollTarget}>
      <Toolbar
        disableGutters
        sx={{
          background: theme.palette.background.canvas,
          padding: "24px",
        }}
      >
        <Box sx={{ marginRight: "12px", ...sxFocusWithin }}>
          <IconButton
            onClick={() => {
              onClose();
            }}
            aria-label="Back"
          >
            <ArrowBackIcon />
          </IconButton>
        </Box>
        <Typography
          component="h1"
          variant="display5"
          ref={titleRef}
          tabIndex={-1}
        >
          {title}
        </Typography>
      </Toolbar>
    </TopAppBar>
  );
};

export default StepsHeader;
